import { useCustomToast } from "@/composables/useCustomToast";
import { useAuthStore } from "@/modules/Auth/stores";
import { computed } from "vue";
import { useBotStore } from "@/modules/Bots/stores";

const { showToast } = useCustomToast();
const store = useAuthStore();
const botStore = useBotStore();
const locale = localStorage.getItem("locale");

const userWalletBalance = computed(() => store.user?.balance);
const userVerified = computed(() => store.user?.is_email_verified);
export function isUserVerified(fn: any, includeWallet: boolean) {
  if (!userVerified.value) {
    showToast(
      locale === "ru"
        ? "Чтобы завершить регистрацию, вам нужно пройти процесс верификации, отправленную на вашу электронную почту."
        : locale === "uz"
          ? "Ro'yxatdan o'tishni yakunlash uchun siz elektron pochtangizga yuborilgan tekshirish jarayonidan o'tishingiz kerak."
          : "To complete the registration, you need to go through the verification process sent to your email.",
      "warning",
    );
  } else if (
    Number(userWalletBalance.value) < 10 &&
    includeWallet &&
    store?.user?.email !== "misha.polvanov2706@gmail.com"
  ) {
    botStore.showWalletWarning = true;
  } else {
    return fn();
  }
}
